import {Resource} from 'simpli-web-sdk'

export class FaturamentoAgendador extends Resource {
  idResponsavelFaturamentoAgendadorPk: number = 0
  idResponsavelFk: number = 0
  paramDataInicio: Date | null = null
  paramDataFim: Date | null = null
  dataAgendamento: Date | null = null
  foiExecutado: boolean | null = null
  ehGrupoEconomico: boolean | null = null
  ehAutomatico: boolean | null = null

  get $id() {
    return this.idResponsavelFaturamentoAgendadorPk
  }
  set $id(val) {
    this.idResponsavelFaturamentoAgendadorPk = val
  }
}
